import React from "react"
import PropTypes from "prop-types"
import TableRow from "material-ui/Table/TableRow"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import FontIcon from "material-ui/FontIcon"
import IconButton from "material-ui/IconButton"
import DropDownMenu from "material-ui/DropDownMenu"
import MenuItem from "material-ui/MenuItem"
const styles = {
    footerContent: {
        float: "right"
    },
    footerText: {
        float: "right",
        paddingTop: 16,
        height: 16
    }
}

const propTypes = {
    onPageClick: PropTypes.func,
    offset: PropTypes.number,
    limit: PropTypes.number,
    total: PropTypes.number,
    onLimitChange: PropTypes.func,
    limitOptions: PropTypes.array
}

const TableFooter = (props) => {
    const onNextClick = () => {
        props.onPageClick(props.offset + props.limit)
    }

    const onPrevClick = () => {
        props.onPageClick(props.offset - props.limit)
    }

    const onFirstClick = () => {
        props.onPageClick(0)
    }

    const onLastClick = () => {
        if (props.total % props.limit === 0) {
            props.onPageClick(props.total - props.limit)
        } else {
            props.onPageClick(props.total - (props.total % props.limit))
        }
    }

    const handleRowsPerPageChange = (event, index, value) => {
        props.onLimitChange(value)
    }

    const offset = props.offset
    const total = props.total
    const limit = props.limit

    return (
        <TableRow className="TableFooter" style={{ borderBottom: 0 }}>
            <TableRowColumn style={styles.footerContent}>
                <IconButton data-intercom-target={"TableFooter-btn-OpenFirstPage"} disabled={offset === 0} onClick={onFirstClick}>
                    <FontIcon className="fa fa-step-backward" />
                </IconButton>
                <IconButton data-intercom-target={"TableFooter-btn-OpenPreviousPage"} disabled={offset === 0} onClick={onPrevClick}>
                    <FontIcon className="fa fa-chevron-left" />
                </IconButton>
                <IconButton data-intercom-target={"TableFooter-btn-OpenNextPage"} disabled={offset + limit >= total} onClick={onNextClick}>
                    <FontIcon className="fa fa-chevron-right" />
                </IconButton>
                <IconButton data-intercom-target={"TableFooter-btn-OpenLastPage"} disabled={offset + limit >= total} onClick={onLastClick}>
                    <FontIcon className="fa fa-step-forward" />
                </IconButton>
            </TableRowColumn>
            <TableRowColumn style={styles.footerText}>{Math.min(offset + 1, total) + "-" + Math.min(offset + limit, total) + " of " + total}</TableRowColumn>
            {props.limitOptions && props.limitOptions.length &&
                <TableRowColumn style={styles.footerContent}>
                    <DropDownMenu value={limit} onChange={handleRowsPerPageChange}>
                        {props.limitOptions.map(function (option, i) {
                            return <MenuItem value={option} primaryText={option} key={i} />
                        })}
                    </DropDownMenu>
                </TableRowColumn>
            }
        </TableRow>
    )
}

TableFooter.propTypes = propTypes

export default TableFooter
